import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

import { getRuntimeConfig } from '../app/runtimeConfig';

const origin = typeof window !== 'undefined' ? window.location.origin : '';
const config = getRuntimeConfig();

// `audience` is required on the authorize call or Auth0 returns an opaque
// access token instead of a JWT.
export const userManager = new UserManager({
  authority: `https://${config.auth0Domain}/`,
  client_id: config.auth0ClientId,
  redirect_uri: `${origin}/auth/callback`,
  silent_redirect_uri: `${origin}/auth/silent-callback`,
  post_logout_redirect_uri: `${origin}/`,
  response_type: 'code',
  scope: 'openid profile email',
  loadUserInfo: false,
  automaticSilentRenew: true,
  extraQueryParams: { audience: config.auth0Audience },
  userStore: new WebStorageStateStore({
    store: typeof window !== 'undefined' ? window.localStorage : undefined,
  }),
});
